module.exports = __webpack_public_path__ + "static/media/green-tick.e4e503d2.svg";